import {
  APICategory,
  AdminAPICategory,
  UnreleasedAPICategory,
  abbreviationForAPICategory as sharedAbbreviationForAPICategory,
  colorForAPICategory as sharedColorForAPICategory,
  descriptionForAPICategory as sharedDescriptionForAPICategory,
  displayNameForAPICategory as sharedDisplayNameForAPICategory,
  fullDisplayNameForAPICategory as sharedFullDisplayNameForAPICategory,
  iconForAPICategory as sharedIconForAPICategory,
} from "@merge-api/merge-javascript-shared";
import { BaseColor } from "@merge-api/merge-javascript-shared/dist/designSystem/types";
import clsx from "clsx";
import { GitBranch } from "lucide-react";

// Not in @merge-api/merge-javascript-shared's UnreleasedAPICategory, so admin defines it here.
export const VERSION_CONTROL_CATEGORY = {
  value: "versioncontrol",
  displayName: "Version Control",
  abbreviation: "VCS",
  color: "green",
  description: "Version Control",
} as const;

export type AdminCategory = AdminAPICategory | typeof VERSION_CONTROL_CATEGORY.value;

export const ADMIN_CATEGORIES: AdminCategory[] = [
  ...Object.values(APICategory),
  ...Object.values(UnreleasedAPICategory),
  VERSION_CONTROL_CATEGORY.value,
];

const isVersionControl = (
  category: AdminCategory
): category is typeof VERSION_CONTROL_CATEGORY.value => category === VERSION_CONTROL_CATEGORY.value;

export const displayNameForAPICategory = (category: AdminCategory): string =>
  isVersionControl(category)
    ? VERSION_CONTROL_CATEGORY.displayName
    : sharedDisplayNameForAPICategory(category);

export const fullDisplayNameForAPICategory = (category: AdminCategory): string =>
  isVersionControl(category)
    ? VERSION_CONTROL_CATEGORY.displayName
    : sharedFullDisplayNameForAPICategory(category);

export const abbreviationForAPICategory = (category: AdminCategory): string =>
  isVersionControl(category)
    ? VERSION_CONTROL_CATEGORY.abbreviation
    : sharedAbbreviationForAPICategory(category);

export const colorForAPICategory = (category: AdminCategory): BaseColor =>
  isVersionControl(category) ? VERSION_CONTROL_CATEGORY.color : sharedColorForAPICategory(category);

export const descriptionForAPICategory = (category: AdminCategory): string =>
  isVersionControl(category)
    ? VERSION_CONTROL_CATEGORY.description
    : sharedDescriptionForAPICategory(category);

export const iconForAPICategory = (
  category: AdminCategory,
  size = 14,
  hasColor = false,
  hasBackground = false
): JSX.Element => {
  if (!isVersionControl(category)) {
    return sharedIconForAPICategory(category, size, hasColor, hasBackground);
  }
  return (
    <div
      className={clsx("flex h-5 w-5 items-center justify-center rounded", {
        "bg-green-0": hasBackground,
      })}
    >
      <GitBranch size={size} className={clsx({ "text-green-50": hasColor })} />
    </div>
  );
};
